import { render, staticRenderFns } from "./Transaction2.vue?vue&type=template&id=68556a94&scoped=true&"
import script from "./Transaction2.vue?vue&type=script&lang=js&"
export * from "./Transaction2.vue?vue&type=script&lang=js&"
import style0 from "./Transaction2.vue?vue&type=style&index=0&id=68556a94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68556a94",
  null
  
)

export default component.exports